// components/bando-card/bando-card.component.ts
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { Bando } from 'src/app/services/obiettivo-europa.service';

@Component({
  selector: 'app-bando-item',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule,
    MatCardModule,
    MatButtonModule
  ],
  templateUrl: './bando-item.component.html',
  styleUrls: ['./bando-item.component.scss']
})
export class BandoItemComponent {
  @Input() bando!: Bando;
  @Output() onBandoClicked = new EventEmitter<Bando>();

  getStatusLabel(status: number): string {
    return status === 1 ? 'Aperto' : 'In uscita';
  }

  getStatusClass(status: number): string {
    return status === 1 ? 'status-open' : 'status-closed';
  }

  formatDeadlineMessage(days: number, deadline: string): string {
    let stringDeadline = 'Scadenza:' + deadline;
    if (days) {
      stringDeadline += ' (' + days + ' giorni alla scadenza)';
    }
    return stringDeadline;
  }


  goToBando(): void {
   this.onBandoClicked.emit(this.bando);
  }


}
